import { render, staticRenderFns } from "./detail-comment.vue?vue&type=template&id=422cc703&scoped=true&"
import script from "./detail-comment.vue?vue&type=script&lang=js&"
export * from "./detail-comment.vue?vue&type=script&lang=js&"
import style0 from "./detail-comment.vue?vue&type=style&index=0&id=422cc703&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "422cc703",
  null
  
)

export default component.exports